import * as React from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const ButtonbarContext = /*#__PURE__*/ React.createContext(null);
const useButtonbarContext = ()=>{
    return useNonNullishContext(ButtonbarContext);
};
const ButtonbarButtonContext = /*#__PURE__*/ React.createContext(undefined);
const useButtonbarButtonContext = ()=>{
    return useNonNullishContext(ButtonbarButtonContext);
};

export { ButtonbarButtonContext, ButtonbarContext, useButtonbarButtonContext, useButtonbarContext };
